import { Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";
import { RichTextRenderer } from "~/components/RichTextRenderer";
import { SvgRenderer } from "~/components/SvgRenderer";
import { cn } from "~/lib/utils";

interface InfoCardProps {
  align?: "left" | "center";
  icon: string | null;
  headline: string;
  text?: string;
  link?: string;
  linkLabel?: string;
}

export const InfoCard = ({
  align,
  icon,
  headline,
  text,
  link,
  linkLabel,
}: InfoCardProps) => {
  return (
    <div
      className={cn(
        "flex flex-col gap-6",
        align === "center" ? "items-center text-center" : "",
      )}
    >
      {icon ? (
        <div className="[&_svg]:w-12 [&_svg]:h-12">
          <SvgRenderer src={icon} />
        </div>
      ) : null}

      <h3 className="text-3xl font-medium">{headline}</h3>

      <RichTextRenderer richText={text || ""} />

      {link && linkLabel && (
        <Link
          className="flex items-center gap-1 font-medium mt-2 hover:underline"
          to={link}
        >
          {linkLabel} <ChevronRight />
        </Link>
      )}
    </div>
  );
};
